import axios, { AxiosResponse } from 'axios';

/**
 * Расчет индивидуального подоходного налога
 */
export const calculateIndividualIncomeTax = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/calculator/calculate-individual-income-tax', data);
};

/**
 * Расчет индивидуального подоходного налога
 */
export const getMRP = (period: string): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/dictionary/mrp_ref/${period}`);
};

/**
 * Расчет индивидуального подоходного налога
 */
export const getMZP = (period: string): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/dictionary/minimum_wage_ref/${period}`);
};



